module.exports = __webpack_public_path__ + "img/other_teddy.3d8d28d6.png";